module.exports = __webpack_public_path__ + "img/lens-167-plus-06.3ed736a9.png";